/**
 * 事件发射器 Hook
 * 提供事件监听、触发等功能
 */

(function (window) {
  function useThrottle(fn, delay, options = {}) {
    const { leading = true, trailing = true } = options;

    let lastTime = 0;
    let timer = null;
    let lastArgs = null;
    let lastThis = null;

    function invoke(time) {
      lastTime = time;
      fn.apply(lastThis, lastArgs);
      lastArgs = lastThis = null;
    }

    function throttled(...args) {
      const now = Date.now();
      if (!lastTime && !leading) lastTime = now;

      const remaining = delay - (now - lastTime);

      lastArgs = args;
      lastThis = this;

      if (remaining <= 0) {
        clearTimeout(timer);
        timer = null;
        invoke(now);
      } else if (trailing && !timer) {
        timer = setTimeout(() => {
          timer = null;
          invoke(Date.now());
        }, remaining);
      }
    }

    throttled.cancel = () => {
      clearTimeout(timer);
      timer = null;
      lastTime = 0;
      lastArgs = lastThis = null;
    };

    return throttled;
  }

  window.useThrottle = useThrottle;
})(window);
